import request from '@/utils/request'

// POST /api/wms/login
export function loginApi(username, password) {
  return request.post('/wms/login', { username, password })
}